import React, { useContext } from 'react';

import styled from '@emotion/styled';

import useVerifyNIN from '../../../../hooks/dashboard/BaDriverVerification/useVerifyNIN';
import { verifyNINAction } from '../../../../redux/slices/verifyNINSlice';
import { useAppDisPatch, useAppSelector } from '../../../../redux/store';
import { FormSubmitButton } from '../../../Button/FormSubmitButton';
import ExclaimIcon from '../../../Icons/ExclaimIcon';
import { ModalContext } from '../../ModalContext';

interface VerifyNINInformationProps {
  data?: any;
}

const VerifyNINInformation: React.FC<VerifyNINInformationProps> = ({
  data,
}) => {
  const modalContext = useContext(ModalContext);
  const dispatch = useAppDisPatch();
  const verifyNINState = useAppSelector((state) => state.verifyNIN);
  const { verifyNIN, loading } = useVerifyNIN();

  const onSubmit = () => {
    console.log('data ------*->', data);
    verifyNIN(
      {
        // nin: data?.nin ?? '',
        // firstName: data?.firstName ?? '',
        // lastName: data?.lastName ?? '',
        nin: data?.nin ?? '',
        firstName: data?.driverName.split(' ')[0] ?? '',
        lastName: data?.driverName.split(' ')[1] ?? '',
      },
      () => {
        dispatch(verifyNINAction.setSliderIndex(1));
      },
    );
  };

  return (
    <Container
      className={verifyNINState.sliderIndex > 1 ? 'inactive' : 'has-height'}
    >
      <Flex>
        <Description>Are you sure you want to verify this NIN?</Description>
        <Banner>
          <ExclaimIcon /> Verification of NIN costs 100 naira
        </Banner>

        <ButtonArea>
          <FormSubmitButton
            className='clear fill text-red'
            onClick={() => modalContext?.setShowModal(false)}
            btnType='button'
          >
            Cancel
          </FormSubmitButton>
          <FormSubmitButton
            btnType='button'
            onClick={onSubmit}
            className='fill'
            loading={loading}
          >
            Verify
          </FormSubmitButton>
        </ButtonArea>
      </Flex>
    </Container>
  );
};

export default VerifyNINInformation;

const Container = styled.div`
  display: flex;
  height: 0px;

  &.inactive > * {
    display: none;
  }

  &.has-height {
    height: auto;
  }
`;

const ButtonArea = styled.div`
  display: flex;
  width: 100%;
  gap: 16px;
`;

const Flex = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  gap: 16px;
`;

const Description = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.palette.grayTextColor};

  & > span {
    font-weight: 600;
  }
`;

const Banner = styled.div`
  font-weight: 600;
  font-size: 16px;
  width: 100%;
  border-radius: 6px;
  padding: 16px;
  background-color: rgba(59, 124, 244, 0.05);
  border-radius: 8px;
  color: #41415a;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;

  & > svg {
    color: #5b91f5;
  }
`;
